<template>
  <div class="about">
    <h1>This is an 404 page</h1>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",
};
</script>

<style scoped></style>
